import { createAvatar } from '@dicebear/avatars'
import * as style from '@dicebear/avatars-jdenticon-sprites'
export function generateProfileImage(seed: string) {
  return createAvatar(style, {
    base64: true,
    seed,
  })
}
